import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";



export const GetAll = createAsyncThunk(
  "privacypolicy/privacypolicy/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.privacypolicy.privacypolicy}?name=${filter?.name || ""}&page=${
          filter?.page || IDS.PAGE
        }&per_page=${filter?.per_page || IDS.PERPAGE}`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const GetSingle = createAsyncThunk(
  "privacypolicy/privacypolicy/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.privacypolicy.privacypolicy}/${id}`);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const Create = createAsyncThunk(
  "privacypolicy/privacypolicy/create",
  async (data, { rejectWithValue }) => {
    try {
  
      const isForm = data instanceof FormData;
      const res = await POST(APIS.privacypolicy.privacypolicy, data, isForm);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

    export const Update = createAsyncThunk(
      "privacypolicy/privacypolicy/update",
      async ({ id, data }, { rejectWithValue }) => {
        try {
          const isForm = data instanceof FormData;

          const res = await PUT(`${APIS.privacypolicy.privacypolicy}/${id}`, data, isForm);

           const payload = res?.data?.success !== undefined 
        ? res.data       
        : res; 

          return payload; 
        } catch (error) {
          return rejectWithValue(error.message);
        }
      }
    );
 


export const Delete = createAsyncThunk(
  "privacypolicy/privacypolicy/delete",
  async (id, { rejectWithValue }) => {
    try {
      await DELETE(`${APIS.privacypolicy.privacypolicy}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Country - Status
export const Status = createAsyncThunk(
  "privacypolicy/privacypolicy/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.privacypolicy.privacypolicy}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const Slice = createSlice({
  name: "privacypolicy",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      /* ------------------ GET ALL ------------------ */
     
      .addCase(GetAll.pending, (state) => {
      state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      /* ------------------ GET SINGLE ------------------ */
      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      /* ------------------ CREATE ------------------ */
      .addCase(Create.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

       if (action.payload?.data) {
          state.data.unshift(action.payload.data);
        }
      })
      .addCase(Create.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      /* ------------------ UPDATE ------------------ */
      .addCase(Update.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Update.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        const updated = action.payload?.data;
        if (!updated) return;

        const index = state.data.findIndex((item) => item.id === updated.id);
        if (index !== -1) {
          state.data[index] = updated;
        }
      })
      .addCase(Update.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      /* ------------------ DELETE ------------------ */
      .addCase(Delete.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Delete.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = state.data.filter((item) => item.id !== action.payload);
      })
      .addCase(Delete.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
    })
      
          .addCase(Status.pending, (state) => {
            state.status = IDS.SLICESTATUS.Loading;
            })
                    
          .addCase(Status.fulfilled, (state, action) => {                 
          state.status = IDS.SLICESTATUS.Succeeded;
                      
          // state.data = action.payload;
          state.data = state.data.filter(
          (home) => home.id !== action.payload.id
          ); // Remove the country with the deleted id
          })
          .addCase(Status.rejected, (state, action) => {
          state.status = IDS.SLICESTATUS.Failed;
          state.error = action.payload;
          })
  ;
  },
});

export default Slice.reducer;

